/** Layout for /admin/workshop (WorkshopOrchestrator). */
import styled from '@emotion/styled';
import { media } from '../styles/breakpoints';

// ─── Layout ──────────────────────────────────────────────────────────

export const Page = styled.div`
  height: var(--kuutio-vh, 100vh);
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #0a0a0a 0%, #1a1a2e 100%);
  overflow: hidden;
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  min-height: 0;
`;

export const MainScroll = styled.div`
  flex: 1;
  overflow-y: auto;
  scroll-snap-type: y proximity;
  position: relative;

  ${media.sm} {
    scroll-snap-type: none;
    padding-bottom: ${p => (p.$flowPad ? '88px' : '0')};
  }
`;

// ─── Empty / Loading States ──────────────────────────────────────────

export const CenterState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #666;
  text-align: center;
  padding: 48px;

  h2 { margin: 0 0 8px; color: #999; font-size: 20px; }
  p  { margin: 0 0 24px; font-size: 14px; }
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(74, 158, 255, 0.2);
  border-top-color: rgba(74, 158, 255, 0.8);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  @keyframes spin { to { transform: rotate(360deg); } }
`;

export const SelectFlowButton = styled.button`
  background: #4a9eff;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover { background: #3a8eef; }
`;

export const ReadinessLink = styled.a`
  display: inline-block;
  margin-top: 4px;
  font-size: 12px;
  color: inherit;
  opacity: 0.8;
  text-decoration: underline;

  &:hover { opacity: 1; }
`;

export const ReadinessBar = styled.div`
  padding: 10px 20px;
  font-size: 13px;
  border-bottom: 1px solid ${p => (p.$ok ? 'rgba(76, 175, 80, 0.3)' : 'rgba(255, 193, 7, 0.4)')};
  background: ${p => (p.$ok ? 'rgba(76, 175, 80, 0.08)' : 'rgba(255, 193, 7, 0.1)')};
  color: ${p => (p.$ok ? '#a5d6a7' : '#ffe082')};
  flex-shrink: 0;
`;

export const NoInstanceState = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #0a0a0a 0%, #1a1a2e 100%);
  display: flex;
  flex-direction: column;
`;

export const NoInstanceContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #666;
  padding: 48px;

  h2 { color: #999; margin: 0 0 8px; }
  p  { margin: 0 0 16px; }
`;
